module.exports = __webpack_public_path__ + "img/achievement_19.96a9f86d.png";